module.exports = __webpack_public_path__ + "img/5_66.1f8627a6.png";